import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { SiteProvider } from "@/context/SiteContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Library from "@/pages/Library";
import PaperReader from "@/pages/PaperReader";
import Donate from "@/pages/Donate";
import Faq from "@/pages/Faq";
import Poster from "@/pages/Poster";
import Admin from "@/pages/Admin";

function ScrollManager() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        document.querySelector(location.hash)?.scrollIntoView({ behavior: "smooth" });
      }, 150);
    } else {
      window.__lenis?.scrollTo(0, { immediate: true });
      window.scrollTo(0, 0);
    }
  }, [location]);
  return null;
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <SiteProvider>
      <BrowserRouter>
        <ScrollManager />
        <div className="min-h-screen bg-[#07090E] text-slate-100 font-sans">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/library" element={<Library />} />
            <Route path="/paper/:slug" element={<PaperReader />} />
            <Route path="/donate" element={<Donate />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/poster" element={<Poster />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <Footer />
        </div>
        <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#131824", border: "1px solid #1E2638", color: "#F8FAFC" } }} />
      </BrowserRouter>
    </SiteProvider>
  );
}
